export const filters = () => ({
        price: [Infinity, 0],
        dates: [],
        name: null,
        shortDescription: null,
        supplierName: [],
    }),
    searchRequest = () => ({
        convertToCurrency: null,
        cityId: null,
        startDate: null,
        endDate: null,
        adults: 1,
        childrenAges: [],
        freeOnly: true,
    }),
    searchResponse = () => ({
        filters: filters(),
        product: [],
        currency: null,
    }),
    bookingFields = () => ({
        BIRTHDATE: {
            mainTouristStatus: 'OPTIONAL',
            allTouristsStatus: 'OPTIONAL',
            childrenStatus: 'OPTIONAL',
        },
        PREFIX: {
            mainTouristStatus: 'OPTIONAL',
            allTouristsStatus: 'OPTIONAL',
            childrenStatus: 'OPTIONAL',
        },
    })
